require('./systemPreferencesManager.i18n.json');
require('./systemPreferencesManager.tpl.html');
require('./systemPreferencesManagerActionRepository.js');
require('./systemPreferencesManagerModel.js');
require('./systemPreferencesRepository.js');
require('./systemPreference/systemPreferenceComponent.js');

/*@ngInject*/
const SystemPreferencesManagerController = function ($rootScope, $scope, $state, authorizationConstants, configurationActionsUtil, configurationConstant, configurationMediator, coreConstant, currentUserModel, databaseDownloadSectionName, defaultPreferenceAction, defaultPreferencesType, loadingBarHandler, localization, modalUtil, navigationStateModel, systemPreferencesManagerModel, userMediator) {

    $scope.viewModel = {
        hasManagePermission: currentUserModel.hasAuthorization(authorizationConstants.MANAGE_BA_STUDIO_PREFERENCES),
        isLoading: true,
        originalSystemPreferences: [],
        systemPreferences: {},
        groupNames: [],
        isGridEmpty: true,
        searchString: '',
        searchDelayInMilliSeconds: 750
    };

    localization.getTranslationByKey('systemPreferencesManager').then(function (translations) {
        $scope.translations = translations;

        $scope.viewModel.searchStringPlaceholder = _.get(translations, 'searchStringPlaceholder');

        $scope.actions = [];
        $scope.context = {
            identifier: 'systemPreferencesManager',
            actions: {},
            fallthrough: null,
            model: {
                contextType: coreConstant.CONTEXT_NONE
            }
        };
        $scope.context.actions[coreConstant.CONTEXT_NONE] = '';

        function loadActions() {
            configurationMediator.loadSystemPreferencesManagerActions().then(function (actions) {
                const allActions = [];
                allActions.push({
                    actions: actions.actions,
                    contextType: $scope.context.model.contextType
                });
                $scope.processActions(allActions);
            });
        }

        $scope.processActions = function (actions) {
            $scope.actions = actions;
            $scope.actionSubTexts = {};

            _.each($scope.actions, function (subAction) {
                _.each(subAction.actions, function (action) {
                    if (action.name === defaultPreferenceAction.SAVE) {
                        action.enabled = false;
                        if (systemPreferencesManagerModel.hasUnsavedChanges()) {
                            $scope.actionSubTexts[action.name] = {
                                class: 'unsavedChanges',
                                text: _.get($scope.translations, 'unsavedChanges')
                            };

                            action.enabled = true;
                        }
                    }

                    if (action.name === defaultPreferenceAction.DISCARD) {
                        action.enabled = systemPreferencesManagerModel.hasUnsavedChanges();
                    }
                });
            });

            $scope.actionsTimeLastModified = new Date().getTime();
        }

        function escapeHtml(htmlString) {
            return htmlString
                .replace(/&amp;/g, '&')
                .replace(/&lt;/g, '<')
                .replace(/&gt;/g, '>')
                .replace(/&quot;/g, '\"')
                .replace(/&#039;/g, '\'')
                .replace(/&apos;/g, '\'');
        }

        function processPreferences(defaultPreferences) {
            $scope.viewModel.originalSystemPreferences = defaultPreferences;

            let processedSystemPreferences = _.cloneDeep(defaultPreferences);
            _.each(processedSystemPreferences, (defaultPreference) => {
                if (_.isNil(defaultPreference.category) || defaultPreference.category === "") {
                    defaultPreference.category = 'Uncategorized';
                }
                defaultPreference.shortDescription = defaultPreference.shortDescription !== null ? escapeHtml(defaultPreference.shortDescription) : null;
                defaultPreference.completeDescription = defaultPreference.completeDescription !== null ? escapeHtml(defaultPreference.completeDescription) : null;
            });

            $scope.viewModel.systemPreferences = _.groupBy(
                _.sortBy(
                    _.filter(processedSystemPreferences, (defaultPreference) => {
                        const lowerSearchString = _.toLower($scope.viewModel.searchString);
                        return _.toLower(defaultPreference.category).includes(lowerSearchString) ||
                            _.toLower(defaultPreference.name).includes(lowerSearchString) ||
                            _.toLower(defaultPreference.shortDescription).includes(lowerSearchString) ||
                            _.toLower(defaultPreference.completeDescription).includes(lowerSearchString);
                    }), (defaultPreference) => {
                        if (_.isNil(defaultPreference.shortDescription) || defaultPreference.shortDescription === "") {
                            return defaultPreference.name;
                        }

                        return defaultPreference.shortDescription;
                    }), 'category');

            $scope.viewModel.groupNames = _.uniq(
                _.map(
                    _.filter(
                        _.sortBy(processedSystemPreferences, 'category'), (defaultPreference) => {
                            return $scope.viewModel.systemPreferences.hasOwnProperty(defaultPreference.category);
                        }), 'category'));
            $scope.viewModel.isLoading = false;
            $scope.viewModel.isGridEmpty = _.isEmpty($scope.viewModel.systemPreferences);
        }

        function loadSystemPreferences() {
            $scope.viewModel.isLoading = true;

            userMediator.restoreViewState('configuration.systemPreferencesManager', $scope.viewModel);

            configurationMediator.getStudioPreferences().then((defaultPreferences) => {
                systemPreferencesManagerModel.setSystemPreferences(defaultPreferences);
                processPreferences(defaultPreferences);
            });
        }

        $scope.onSearchStringChanged = function () {
            userMediator.saveViewState('configuration.systemPreferencesManager', {searchString: $scope.viewModel.searchString});
            loadSystemPreferences();
        };

        function resetNavigationState() {
            navigationStateModel.saveViewState('configuration.systemPreferencesManager', null);
        }

        $scope.handleAction = function (action, file) {
            if (action.enabled) {
                switch (action.name) {
                    case defaultPreferenceAction.SAVE:
                        loadingBarHandler.showNotificationLoadingBar(_.get(translations, 'saveSystemPreferences.loadingBar'));
                        configurationMediator.saveStudioPreferences(systemPreferencesManagerModel.getSystemPreferences()).then(function () {
                            systemPreferencesManagerModel.setUnsavedChanges(false);
                            $scope.processActions($scope.actions);
                            loadingBarHandler.concludeNotificationLoadingBar(_.get(translations, 'saveSystemPreferences.savingSystemPreferencesSuccessLoadingBar'));
                        });
                        break;

                    case defaultPreferenceAction.DISCARD:
                        modalUtil.showConfirmationModal(null, null, null, 'systemPreferencesManager.discardConfirmation', null, true, function () {
                            $rootScope.$broadcast(coreConstant.event.SHOW_FADING_NOTIFICATION, _.get(translations, 'discardConfirmation.success'));
                            systemPreferencesManagerModel.setUnsavedChanges(false);
                            $state.reload();
                        });
                        break;

                    case defaultPreferenceAction.BACKUP:
                        configurationActionsUtil.backup(databaseDownloadSectionName.DEFAULT_PREFERENCES, _.get(translations, 'backup.name'), _.get(translations, 'backup.loadingBar'), _.get(translations, 'backup.successMessage'));
                        break;

                    default:
                        modalUtil.showActionNotImplementedModal(action.name);
                        break;
                }
            }
        };

        $scope.$on(configurationConstant.event.SYSTEM_PREFERENCES_MANAGER_MODEL_UPDATED, function () {
            $scope.processActions($scope.actions);
        });

        $scope.$on('$stateChangeStart', (event, toState, toParams, fromState) => {
            const isCurrentStateSystemPreferencesManager = _.startsWith(fromState.name, 'configuration.systemPreferencesManager'),
                isTargetSameAsCurrent = toState.name === fromState.name;

            if (toState.name === 'login') {
                return;
            }

            if (systemPreferencesManagerModel.hasUnsavedChanges() && isCurrentStateSystemPreferencesManager && !isTargetSameAsCurrent && systemPreferencesManagerModel.getSystemPreferences()) {
                event.preventDefault();

                loadingBarHandler.showNotificationLoadingBar(_.get(translations, 'saveSystemPreferences.loadingBar'));
                configurationMediator.saveStudioPreferences(systemPreferencesManagerModel.getSystemPreferences()).then(function () {
                    systemPreferencesManagerModel.setUnsavedChanges(false);
                    loadingBarHandler.concludeNotificationLoadingBar(_.get(translations, 'saveSystemPreferences.savingSystemPreferencesSuccessLoadingBar'));
                    $state.go(toState, toParams);
                });
            } else {
                if (isCurrentStateSystemPreferencesManager && isTargetSameAsCurrent && systemPreferencesManagerModel.hasUnsavedChanges()) {
                    systemPreferencesManagerModel.setUnsavedChanges(false);
                    $state.reload();
                }
            }
        });

        loadActions();
        loadSystemPreferences();
        resetNavigationState();
    });
};

angular.module('ums.configuration')
    .controller('systemPreferencesManagerController', SystemPreferencesManagerController);
